import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { ImageTileItem } from '@usf/ngrx-tools/lib/model/image-tile';

@Component({
  selector: 'app-image-tile',
  templateUrl: './image-tile.component.html',
  styleUrls: ['./image-tile.component.scss'],
})
export class ImageTileComponent {
  @Input() imageItem: ImageTileItem;
  @Input() platform: PlatformEnum;
  @Output() clickEvent = new EventEmitter<ImageTileItem>();

  platformRef = PlatformEnum;
  constructor() {}

  onClick() {
    if (!this.imageItem.disabled) this.clickEvent.emit(this.imageItem);
  }
}
